import React, { useState, useEffect, useRef } from "react";
import { withTranslation } from "react-i18next";
import avatar2 from "../../../assets/images/users/avatar-2.jpg";

function ProfileMenu({ t }) {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("Admin");
  const dropdownRef = useRef(null);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("authUser");
      if (storedUser) {
        const obj = JSON.parse(storedUser);
        const email = obj?.user?.name;
        if (email && typeof email === "string") {
          const uNm = email.split("@")[0];
          setUsername(uNm.charAt(0).toUpperCase() + uNm.slice(1));
        }
      }
    } catch (error) {
      console.error("Error retrieving auth user:", error);
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setMenu(false);
      }
    }
    if (menu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menu]);

  const lockScreen = () => {
    localStorage.setItem("isLocked", "true");
    window.location.href = "/lock-screen";
  };
  const toggle = () => setMenu((prev) => !prev);

  return (
    <div
      className={`dropdown d-inline-block user-dropdown${menu ? " show" : ""}`}
      ref={dropdownRef}
    >
      <button
        type="button"
        className="btn header-item waves-effect"
        id="page-header-user-dropdown"
        onClick={toggle}
        aria-expanded={menu}
        aria-haspopup="true"
      >
        <img
          className="rounded-circle header-profile-user me-1"
          src={avatar2}
          alt="Header Avatar"
        />
        <span className="d-none d-xl-inline-block ms-1 text-transform">
          {t(username, { defaultValue: username })}
        </span>
        <i className="mdi mdi-chevron-down d-none ms-1 d-xl-inline-block"></i>
      </button>
      <div
        className={`dropdown-menu dropdown-menu-end${menu ? " show" : ""}`}
        aria-labelledby="page-header-user-dropdown"
      >
        <a className="dropdown-item" href="/profile">
          <i className="ri-user-line align-middle me-1"></i> {t("Profile")}
        </a>
        <a className="dropdown-item d-block" href="#">
          <span className="badge badge-success float-end mt-1">11</span>
          <i className="ri-settings-2-line align-middle me-1"></i> {t("Settings")}
        </a>
        <a className="dropdown-item" href="/lock-screen" onClick={lockScreen}>
          <i className="ri-lock-unlock-line align-middle me-1"></i> {t("Lock screen")}
        </a>
        <div className="dropdown-divider"></div>
        <a className="dropdown-item text-danger" href="/logout">
          <i className="ri-shut-down-line align-middle me-1 text-danger"></i> {t("Logout")}
        </a>
      </div>
    </div>
  );
}

export default withTranslation()(ProfileMenu);
